// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"199":"fxa-common-password-list","447":"fxaPairingChannel","791":"fast-text-encoding","982":"fxaCryptoDeriver"}[chunkId] || chunkId) + ".bundle.js";
};